import moment from "moment";

export function getDateSubtitle(startDate: string, endDate?: string) {
  if (!endDate) {
    return "Para sempre";
  }

  const isEqualMonth =
    moment(startDate).format("MM-YYYY") === moment(endDate).format("MM-YYYY");

  if (
    isEqualMonth &&
    moment(startDate).format("MM-YYYY") === moment().format("MM-YYYY")
  ) {
    return `Apenas ${moment(endDate).format("MMM/YYYY")}`;
  }

  if (isEqualMonth) {
    return "Apenas este mês";
  }

  return `De ${moment(startDate).format("MMM/YYYY")} até ${moment(
    endDate
  ).format("MMM/YYYY")}`;
}

export function getTypeTag(extra: boolean) {
  if (extra) {
    return "Boleto extra";
  }
  return "Boleto normal";
}
